import { LocationProvider, RedirectCatcher } from '@xing-com/crate-core-router';

export type BrowserRootProps = React.PropsWithChildren;

export const BrowserRoot: React.FC<BrowserRootProps> = ({ children }) => {
  return (
    <LocationProvider>
      <RedirectCatcher>{children}</RedirectCatcher>
    </LocationProvider>
  );
};
